import React from 'react';
import cx from 'classnames';

import { IPageFields } from '../../../types/contentful';

import { usePageDataContext } from '../../context/PageData';
import { getPartnerPageHeader } from '../../lib/partnerPages/getPartnerPageContent';

import { AffiliateHeader } from '../AffiliateHeader';
import { Navbar } from '../Navbar';
import { VariationContainer } from '../VariationContainer';
import { findPartnerHeader } from '~/utils/gl4cPartner';

export function Headers({
  headerType,
  hideHeader,
  hideBanner,
  gl4cPartnerHeaders
}: IPageFields) {
  const {
    config,
    partnerPageConfig,
    slug,
    cookies: { partner: partner } = {}
  } = usePageDataContext();

  // Use partner page header if available, otherwise fall back to global header
  const header = getPartnerPageHeader({
    slug: slug || '',
    globalConfig: config,
    partnerPageConfig
  });

  // If page query returns 'headerType' data, show either regular Header... or Affiliate Header.
  // If page query returns 'contentfulGlobalConfig' data, show either: regular Header... or Variation Container
  // Usage
  const matchingHeader = findPartnerHeader(gl4cPartnerHeaders, partner);

  if (matchingHeader) {
    headerType = matchingHeader;
  }

  const { sys, fields }: any = headerType ?? header ?? {};

  const contentType = sys?.contentType?.sys?.id;
  const isAffiliate = contentType === 'affiliateHeader';
  const showHeader = !hideHeader || !hideBanner;

  return (
    <header
      className={cx('top-0 w-full', {
        hidden: !showHeader,
        'flex flex-col justify-center': showHeader,
        relative: isAffiliate,
        'sticky z-[999]': !isAffiliate
      })}
      data-testid="fixed-header"
    >
      {!hideHeader &&
        (() => {
          switch (contentType) {
            case 'affiliateHeader':
              return <AffiliateHeader {...fields} />;

            case 'header2':
              return <Navbar {...fields} />;

            case 'variationContainer':
              return <VariationContainer {...fields} sysId={sys?.id} />;

            default:
              return null;
          }
        })()}
    </header>
  );
}
